import React, { useEffect, useState }  from 'react'
import logo from '../Images/logo-main-white.png'
import {NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileInvoice, faHome } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons'
import { faUsd } from '@fortawesome/free-solid-svg-icons'
import { faVideoCamera } from '@fortawesome/free-solid-svg-icons'
import { faBicycle } from '@fortawesome/free-solid-svg-icons';
import { faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import { faCompass } from '@fortawesome/free-solid-svg-icons';

// firebase
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import useInterviewMenuAccess from './useInterviewMenuAccess';

//routers
import {useNavigate } from "react-router-dom";

function Leftmenu() {

    let navigate = useNavigate();
    const hasInterviewMenuAccess = useInterviewMenuAccess();
    const [canViewStudentTrainee, setCanViewStudentTrainee] = useState(false);

    const auth = getAuth();
    useEffect(() => {
        let isMounted = true;

        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (!user) {
                if (isMounted) {
                    setCanViewStudentTrainee(false);
                }
                navigate("/login")
                return;
            }

            try {
                const userSnapshot = await getDocs(query(collection(db, 'users'), where('userId', '==', user.uid)));
                let nextCanViewStudentTrainee = false;

                userSnapshot.forEach((snapshotDoc) => {
                    const status = (snapshotDoc.data().userStatus || snapshotDoc.data().Status || '').toString().trim().toLowerCase();
                    if (status === 'completed') {
                        nextCanViewStudentTrainee = true;
                    }
                });

                if (isMounted) {
                    setCanViewStudentTrainee(nextCanViewStudentTrainee);
                }
            } catch (error) {
                console.error('Failed to load trainee menu access:', error);
                if (isMounted) {
                    setCanViewStudentTrainee(false);
                }
            }
        });

        return () => {
            isMounted = false;
            unsubscribe();
        };
    }, [auth, navigate]);

  return (
    <div className='leftNav'>
   
        <img src={logo} alt="" className='dashnavLogo' />
      
      
        <br />
        

        <NavLink to="/dashboard" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faHome} className="laftNavIcon activelaftNavIcon"/>
            Dashboard
        </NavLink>

        <NavLink to="/academic" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faBicycle} className="laftNavIcon"/>
            My Courses
        </NavLink>

        {canViewStudentTrainee && (
            <NavLink to="/student-trainee" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
                <FontAwesomeIcon icon={faUserGraduate} className="laftNavIcon"/>
                Student Trainee
            </NavLink>
        )}

        <NavLink to="/my-rooms" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faVideoCamera} className="laftNavIcon"/>
            Live Classes
        </NavLink> 

        {hasInterviewMenuAccess && (
            <NavLink to="/interviews" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
                <FontAwesomeIcon icon={faCalendarDay} className="laftNavIcon"/>
                Interviews
            </NavLink>
        )}

        {/* <NavLink to="/tasks" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faBookmark} className="laftNavIcon"/>
            Assigments   
            <span className='leftLinkNotif'>0</span>   
        </NavLink> */}

        {/* <NavLink to="/ubunifu-firefly" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faMagic} className="laftNavIcon"/>
            Ubunifu Firefly
        </NavLink> */}

        <NavLink to="/firefly-reports" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faFileInvoice} className="laftNavIcon"/>
            My Firefly Reports
        </NavLink>


        {/* className={`leftLinkCont d-flex align-items-center ${activeMenu3}`} */}

                <hr />



        <NavLink to="/fee-invoices" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faFileInvoice} className="laftNavIcon "/>
            Fee Invoices
        </NavLink>

        <NavLink to="/fee-report" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faUsd} className="laftNavIcon "/>
            Fee Payments
        </NavLink>

        <NavLink to="/class-reports" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faCalendarDay} className="laftNavIcon "/>
            Attendance Report
        </NavLink>

        {/* <p>RESEARCH & DEV</p>

        <NavLink to="/assigned-profects" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faCoffee} className="laftNavIcon"/>
            Projects Hub
        </NavLink>

        <NavLink to="/startups" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faLightbulb} className="laftNavIcon"/>
            My Startups
        </NavLink>

        <NavLink to="/startup-corner" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faBriefcase} className="laftNavIcon"/>
            Startup Corner
        </NavLink>

        <NavLink to="/job-board" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faBuilding} className="laftNavIcon"/>
            Job Board
        </NavLink> */}
        
        <hr />
        
        <NavLink to="/profile" className='leftNavLinks leftLinkCont d-flex align-items-center' activeclassname="active">
            <FontAwesomeIcon icon={faUser} className="laftNavIcon "/>
            Profile
        </NavLink>


      

    </div>
  )
}

export default Leftmenu
